module.exports = __webpack_public_path__ + "static/media/district.149392de.jpg";